var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-1"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-btn',{staticClass:"btnReport",attrs:{"color":"#FFD600","to":'/weserve_admin_login/control/' +
          _vm.$store.state.backOffice.province +
          '/report/sale_messenger_report'}},[_c('v-icon',[_vm._v("insert_drive_file")]),_c('span',{},[_vm._v("sale messenger report")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }